<template>
  <div>
    <div class="address-list" v-if="addresses.length">
      <div
        class="item"
        v-for="addressInfo in addresses"
        :key="addressInfo.id"
        @click="handleSelectAddress(addressInfo)"
      >
        <div class="area fs-36">{{ addressInfo.province }} {{ addressInfo.city }} {{ addressInfo.area }}</div>
        <div class="address wb-ba">
          <span class="fs-45">{{ addressInfo.detailAddress }}</span>
          <span class="select-icon" v-if="addressInfo.isDefault"></span>
        </div>
        <div class="linkman fs-36 wb-ba">
          <span class="lc-1 name">{{ addressInfo.receiverName }}</span>
          <span class="phone">{{ addressInfo.mobilePhone | encryptMobile }}</span>
        </div>
        <div class="actions-panel">
          <div class="action-left">
            <template v-if="addressInfo.id === addressId">
              <v-checkbox :value="true" class="checkbox"></v-checkbox>
              <span class="fs-36 select-label">已选</span>
            </template>
            <v-checkbox :value="false" class="checkbox" v-else></v-checkbox>
            <!-- <v-icon name="unselected" class="checkbox fs-36" v-else></v-icon> -->
          </div>
          <div class="action-right" v-if="!disabledDel || !disabledEdit">
            <div v-if="!disabledDel" class="action-del" @click.stop="handleDeleteAddress(addressInfo.id)" />
            <div v-if="!disabledEdit" class="action-edit" @click.stop="gotoEditAddress(addressInfo)" />
          </div>
        </div>
      </div>
    </div>
    <div class="address-empty" v-else>
      <img src="../img/address-empty.png" />
      <p class="fs-42 tip">{{ isPickUp ? '没有取件地址' : '没有收货地址' }}</p>
    </div>
  </div>
</template>
<script>
import { encryptMobile } from 'utils/common'
export default {
  name: 'address-select',
  filters: {
    encryptMobile
  },
  props: {
    addresses: {
      type: Array,
      default: []
    },
    addressId: {
      type: Number,
      default: 0
    },
    isPickUp: {
      type: Boolean,
      default: false
    },
    disabledEdit:{
      type: Boolean,
      default: false
    },
    disabledDel:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleDeleteAddress(id) {
      this.$osDialog.confirm({
        backClosePopup: true,
        maskClosable: true,
        content: this.isPickUp ? '确定删除取件地址？' : '确定删除收货地址？',
        onConfirm: () => {
          this.$emit('clear', id)
        }
      })
    },
    // 切换地址
    handleSelectAddress(address) {
      this.$emit('change', address)
    },
    // 去新建地址
    goToNewAddress() {
      this.$emit('goToNewAddress', {})
    },
    // 去编辑地址
    gotoEditAddress(address) {
      this.$emit('goToNewAddress', address)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .address-list .select-icon {
    margin-bottom: 8px;
  }
}
.vivo-fontscale-5 {
  .address-list .select-icon {
    margin-bottom: 12px;
  }
}
</style>
